import React, { useEffect, useRef, useState } from 'react'
import '../../global'
import Spinner from '../../components/LoadingSpinner'
import { preLoadImage } from '../../components/Image/ImageObject'
import { Platform, Image } from 'react-native'
import { getOrgData, mergeCheckoutConfig } from './getOrgData'
import RNRestart from 'react-native-restart'
import { auth } from '../../firebase/config'
import { StripeLoader } from '../../components/Stripe/StripeLoader'
import { getPromoImageData } from './getPromoImageData'
import { getThirdPartyPOSTypes } from './getThirdPartyPOSTypes'
import { getLoyaltyRewardData } from './getLoyaltyRewardData'
import { Helmet } from 'react-helmet'
import { getPickupPoints } from './getPickupPoints'
import { getCuisines } from './getCuisines'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { setDataState } from '../../state/Slices/dataSlice'
import {
	DEFAULT_CHECKOUT_CONFIG,
	setSettingsState,
	showAlert,
} from '../../state/Slices/settingsSlice'
import { setPersistedState } from '../../state/Slices/persistedSlice'
import { validateItems } from './validateItems'
import useAuthOrders from './useAuthOrders'
import useRestaurantListeners from './ListenerHooks/useRestaurantsListener'
import useUserListener from './ListenerHooks/useUserListener'
import Colors from '../../constants/Colors'
import { getOrgCuisinesData } from './getOrgCuisineData'
import { initializeAnalytics } from '../../helpers/analytics'

export default function RetrieveData({ children, referralCode, loadingTracker }) {
	const dispatch = useAppDispatch()
	const { loadedData, allDataLoaded, stripePublishableKey } = useAppSelector(state => state.data)
	const { cart, isTestMode } = useAppSelector(state => state.persisted)
	const { isOrderProcessing } = useAppSelector(state => state.checkout)
	const _ = require('lodash')

	const [stripePublishableKeyLocalState, setStripePublishableKey] = useState('')
	const [spinner, setSpinner] = useState(true)
	const [loading, setLoading] = useState(true)
	const [appleAppId, setAppleAppId] = useState('')

	const ref = useRef(null)
	global.payRef = ref

	const [menuItemObject, setMenuItemObject] = useState(null)
	const [modifierObject, setModifierObject] = useState(null)
	const [restaurantObject, setRestaurantObject] = useState(null)

	useAuthOrders()

	useEffect(() => {
		const fetchData = async () => {
			try {
				const orgObject = {}
				console.log('LOADING DATA ' + new Date().toLocaleString())

				const [
					orgData,
					promoImageObject,
					thirdPartyPOSTypes,
					loyaltyRewardObject,
					pickupPoints,
					cuisineObject,
					orgCuisineObject,
				] = await Promise.all([
					getOrgData(),
					getPromoImageData(),
					getThirdPartyPOSTypes(),
					getLoyaltyRewardData(),
					getPickupPoints(),
					getCuisines(),
					getOrgCuisinesData(),
				])
				console.log('ORGANIZATION DATA LOADED ' + new Date().toLocaleString())

				const data: any = orgData

				console.log('data', data)

				const restaurantIds = data.restaurants

				// const { restaurantObject, menuItemObject, modifierObject, menuObject, taxObject } =
				// 	await getRestaurantData(menuItemCategoryObject, restaurantIds)

				// Validate the cart with loaded menu items and restaurant data
				//validateItems(menuItemObject, modifierObject, restaurantObject, dispatch, cart)

				//const restaurantArray = arrayFromObjects(restaurantObject)

				setAppleAppId(data.iosAppId || '')
				global.dineIn = data.dineInEnabled || false
				orgObject[global.org] = data

				// Handle Stripe keys
				if (data.stripe?.publishableKey) {
					setStripePublishableKey(
						data.environment === 'production'
							? data.stripe.publishableKey.production
							: data.stripe.publishableKey.sandbox
					)
				}

				// Set active restaurant ID
				// if (restaurantArray.length === 1) {
				// 	dispatch(setPersistedState({ activeRID: restaurantArray[0].id }))
				// }

				// Merge all fetched data together
				const updatedData = _.merge(
					{},
					//menuObject,
					//taxObject,
					orgObject,
					loadedData,
					//restaurantObject,
					//modifierObject,
					//menuItemObject,
					promoImageObject,
					thirdPartyPOSTypes,
					loyaltyRewardObject,
					pickupPoints,
					cuisineObject,
					orgCuisineObject
					//{ restaurants: restaurantArray }
				)
				// Handle pickup points logic
				if (data.pickupPointsEnabled && updatedData['pickupPoints']?.length === 1) {
					dispatch(setPersistedState({ selectedPickupPoint: updatedData['pickupPoints'][0] }))
				}

				// Set organization color and logo
				let orgLogo = data.logo || ''
				if (global.kiosk && data.kioskLogo) {
					orgLogo = data.kioskLogo
				}
				global.orgColor = global.kiosk && data.kioskColor ? data.kioskColor : data.color
				global.orgColor2 = data.textColor || '#848484'

				// Set the document style on web
				// Avoid background color of the bottom of the page being the same as the org color.
				if (Platform.OS === 'web') {
					document.documentElement.style.setProperty(
						'--safe-area-color',
						data?.appDisplayOptions.backgroundColor || '#f8f8f8'
					)
				}

				// Dispatch settings state
				dispatch(
					setSettingsState({
						delivery: {
							freeDeliveryMultiplier: data.delivery?.freeDeliveryMultiplier || -1,
							isSandbox: data.delivery?.isSandbox || data.environment === 'sandbox',
							orgCoverage: data.delivery?.organizationCoverage?.amount || 0,
							orgCoverageType: data.delivery?.organizationCoverage?.type || '',
							actionIfUndeliverable:
								data.delivery?.actionIfUndeliverable === 'dispose' ? 'dispose' : 'return_to_pickup',
							pickupInstructions: data.delivery?.pickupInstructions || '',
							minSpend: data.delivery?.minimumOrder || 0,
							freeDeliveryMinimumOrder: data.delivery?.freeDeliveryMinimumOrder || null,
						},
						deliveryOrgReceivedPercent: data.delivery?.organizationCoverage?.coveragePercent ?? 100,
						serviceFee: data.serviceFee ?? 0,
						serviceFeeGST: data.serviceFeeGST ?? 0,
						serviceFeePST: data.serviceFeePST ?? 0,
						scheduleDaysAhead: data.scheduleDaysAhead ?? 14,
						scheduleTimeInterval: data.scheduleTimeInterval ?? 15,
						localTimezone: data.timezone ?? 'America/Vancouver',
						allowOrdersOutsideOrgHours:
							data.allowOrdersOutsideOrgHours === 'single' ||
							data.allowOrdersOutsideOrgHours === 'multi'
								? true
								: false,
						outsideOrgHoursOrderType: data.allowOrdersOutsideOrgHours,
						pickupPointsEnabled: data.pickupPointsEnabled || false,
						isSingleBrand: data.singleBrandEnabled || false,
						posLoyaltyEnabled: data.posLoyaltyEnabled || false,
						dineInEnabled: data.dineInEnabled || false,
						usesTableNumbers: data.usesTableNumbers || false,
						posProvider: data.posProvider || '',
						paymentProvider: data.paymentProvider || 'stripe',
						isSandbox: data.environment === 'sandbox',
						webOrdersEnabled: data.webOrdersEnabled ?? true,
						deliveryEnabled:
							data.delivery?.enabled && !global.kiosk ? data.delivery?.enabled : false,
						checkoutConfig: mergeCheckoutConfig(DEFAULT_CHECKOUT_CONFIG, data.checkoutConfig ?? {}),
						enableGiftCard: data.enableGiftCard ?? false,
						privacyPolicy: {
							emailAddress: data?.privacyPolicy?.emailAddress,
						},
						appDisplayOptions: {
							homeLayout: data?.appDisplayOptions?.homeLayout || 'categories',
							showRestaurants: data?.appDisplayOptions?.showRestaurants || false,
							showCategories: data?.appDisplayOptions?.showCategories || false,
							showBrands: data?.appDisplayOptions?.showBrands || false,
							showLoyalty: data?.appDisplayOptions?.showLoyalty || false,
							showCuisines: data?.appDisplayOptions?.showCuisines || false,
							showDisclaimerText: data?.appDisplayOptions?.showDisclaimerText || false,
							randomizeRestaurantDisplay:
								data?.appDisplayOptions?.randomizeRestaurantDisplay ?? false,
							showTermsOfUse: data?.appDisplayOptions?.showTermsOfUse ?? false,
							banner: {
								mobile: data?.appDisplayOptions?.banner?.mobile || null,
								desktop: data?.appDisplayOptions?.banner?.desktop || null,
								backgroundColor: data?.appDisplayOptions?.banner?.backgroundColor || null,
							},
							kiosk: {
								startScreenImage: data?.appDisplayOptions?.kiosk?.startScreenImage || null,
							},
							showTipRestaurant: data?.appDisplayOptions?.showTipRestaurant ?? false,
							styles: {
								backgroundColor: data?.appDisplayOptions?.styles?.backgroundColor || '#f8f8f8',
								buttonAlternateColor:
									data?.appDisplayOptions?.styles?.buttonAlternateColor || Colors.greyscale[2],
								hasBoxShadow: data?.appDisplayOptions?.styles?.hasBoxShadow ?? true,
							},
						},
						address: data?.address,
						customTipOptions: {
							delivery: data?.customTipOptions?.delivery,
							pickup: data?.customTipOptions?.pickup,
							kiosk: data?.customTipOptions?.kiosk,
						},
						country: data?.country?.toUpperCase() || 'CA',
					})
				)

				global.ignorePrepTimeAtClose = data.ignorePrepTimeAtClose ?? false

				// Dispatch data state
				dispatch(
					setDataState({
						loadedData: updatedData,
						//restaurants: restaurantArray,
						webAppURL: data.webURL || '',
						iosAppId: data.iosAppId || '',
						organizationLogo: orgLogo,
						organizationLogoDark: data.logoDark || '',
						emailLogo: data.emailLogo || orgLogo || '',
						stripePublishableKey:
							stripePublishableKeyLocalState !== '' && !isTestMode
								? stripePublishableKeyLocalState
								: data.environment === 'sandbox' || isTestMode
									? data.stripe?.publishableKey?.sandbox
									: data.stripe?.publishableKey?.production,
						//restaurantList: restaurantArray,
						allDataLoaded: true,
						restaurantIds: restaurantIds,
					})
				)

				// Preload images
				if (Platform.OS !== 'web') {
					if (data.organizationHeader) preLoadImage(data.organizationHeader)
					if (data.logo) preLoadImage(data.logo)
					if (data.logoDark) preLoadImage(data.logoDark)
					if (data.kioskOrganizationLogo) preLoadImage(data.kioskOrganizationLogo)
				}

				// Update UI state
				//setSpinner(false)
			} catch (error) {
				console.error(error)
				if (global.kiosk) {
					dispatch(
						showAlert({
							title: 'Error loading data!',
							body: '',
							colorA: 'black',
							colorB: Colors.greyscale[5],
							buttonA: 'Logout',
							buttonB: 'Refresh',
							onPressB: () => {
								RNRestart.Restart()
							},
							onPressA: () => {
								auth.signOut()
								RNRestart.Restart()
							},
						})
					)
				} else {
					dispatch(
						showAlert({
							title: 'Error loading data!',
							buttonA: 'Refresh',
							colorA: global.orgColor ?? 'black',
							onPressA: () => {
								RNRestart.Restart()
							},
						})
					)
				}
			}
		}

		fetchData()
	}, [])
	useUserListener()
	useRestaurantListeners(setSpinner, setRestaurantObject, setMenuItemObject, setModifierObject)

	useEffect(() => {
		if (!spinner) {
			if (loadingTracker !== null) loadingTracker(true)
		}
		if (!spinner && allDataLoaded) {
			// Ensure the data is available before calling validateItems
			if (menuItemObject && modifierObject && restaurantObject) {
				console.log('VALIDATING CART')
				validateItems(
					menuItemObject,
					modifierObject,
					restaurantObject,
					dispatch,
					cart,
					isOrderProcessing
				)
			}
			setLoading(false)
			console.log('ALL DATA LOADED ' + new Date().toLocaleString())
		}
	}, [spinner, allDataLoaded, menuItemObject, modifierObject, restaurantObject])

	useEffect(() => {
		if (loading || Platform.OS !== 'web' || !loadedData[global.org] || !loadedData[global.org])
			return

		initializeAnalytics(
			loadedData[global.org]?.metaPlatforms?.pixelId,
			loadedData[global.org]?.googleAnalytics?.measurementId
		)
	}, [loading, global.org])

	return (
		<>
			{Platform.OS === 'web' && appleAppId && (
				<Helmet>
					<meta name="apple-itunes-app" content={`app-id=${appleAppId}`} />
				</Helmet>
			)}
			<Spinner
				visible={global.kiosk ? !allDataLoaded : spinner && loading}
				overlayColor="rgba(255, 255, 255, 1)"
				headerHeight={0}
				footerHeight={0}
				color="black"
				customIndicator={
					<Image
						style={{ width: 100, height: 100, alignSelf: 'center', marginTop: -20 }}
						source={require('../../assets/images/loadImg.gif')}
					/>
				}
			/>
			{!spinner && !loading && (
				<StripeLoader
					stripePublishableKey={
						stripePublishableKey === '' ? stripePublishableKeyLocalState : stripePublishableKey
					}
				>
					{children}
				</StripeLoader>
			)}
		</>
	)
}
